<span
  *ngIf="displayedConfiguration"
  [id]="id + '3aeb6c6c-3317-46e2-aa12-92df7e9ac885'"
  [class]="'tag ' + displayedConfiguration.class"
  [class.ml-2]="leftMargin"
  [class.transparent]="transparent"
  [tooltipClass]="displayedConfiguration.tooltipClass ?? ''"
  [yatTooltip]="(displayedConfiguration.tooltipText | async) ?? ''"
  [disableTooltip]="!displayedConfiguration.tooltipText">
  <yat-icon id="83882ebe-db7d-4a4a-ada6-d91731d73bc6" class="status-icon" [ngClass]="displayedConfiguration.class" *ngIf="transparent" [name]="displayedConfiguration.icon"> </yat-icon>
  {{ displayedConfiguration.tagText | async }}</span
>
